import api from '@core/services/api/_api';
import ENUMS from '@core/classes/Enums';
import moment from 'moment';
import util from '@core/services/util';
import MapsService from '@core/services/maps';
import $modal from '@core/services/modal';
import modalConfirmCustomerApplicationInfo from '@core/modals/customerApp/modalConfirmCustomerApplicationInfo.vue';
import modalCustomerApplicationInfo from '@core/modals/customerApp/modalCustomerApplicationInfo.vue';
import modalInfo from '@core/modals/modalInfo.vue';
import LogRocket from 'logrocket';
import Application from './Application';
import ApplicationsPreFilledData from './ApplicationsPreFilledData';
import ApplicationsQuoteAppData from './ApplicationsQuoteAppData';
import ApplicationsDataAnswered from './ApplicationsDataAnswered';
import ApplicationsPersonalInfo from './ApplicationsPersonalInfo';
import ApplicationsRebates from './ApplicationsRebates';
import DocumentAssociation from '@core/classes/DocumentAssociation';
import { redirectToCustomerPortal } from '@core/helpers/Customer/customer-helper';
import settings from 'settings';

export function resetDateCompleted(value, extraSaves, question, application) {
	if (application.dateCompleted != null && application.status == ENUMS.CUSTOMER_APPLICATION_STATUS.CompletedNoCredit) {
		application.dateCompleted = null;
	}
}

export async function findPlaidCustomerRecord(value, extraSaves, question, application) {
	if (!application.plaidId) {
		let documentAssociations = [
			new DocumentAssociation({
				type: ENUMS.DOC_ASSOCIATION.Customer,
				id: application.customerId,
			}),
		];
		let response = await api.plaid.getPastPlaidExchanges(documentAssociations, ENUMS.PLAID_INTERACTION.GetIdentityVerification);

		if (response && response.data && response.data.length > 0) {
			const plaidData = response.data.sort((a, b) => (a.timestamp < b.timestamp ? 1 : -1)).find(r => r.identityVerification != null).identityVerification.response;
			await plaidInfo(plaidData, extraSaves, question, application);
		}
	}
}

export async function plaidInfo(plaidData, extraSaves, question, application) {
	if (plaidData && plaidData.clientUserId) {
		application.plaidId = plaidData.clientUserId;
		console.log('PlaidData', plaidData);

		let driverLicense = plaidData.documentaryVerification?.documents?.find(d => d.extractedData?.category == 0)?.extractedData;
		if (driverLicense) {
			let driverLicenseObj = {
				type: 1,
				idNumber: driverLicense.idNumber,
				jurisdiction: driverLicense.issuingRegion,
				expirationDate: moment(driverLicense.expirationDate, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]'),
			};

			application.quoteAppData.applicationsDataAnswered.personalInfo.identifications.push(driverLicenseObj);
		}
	}
}

//TODO: In the future, we will refactor the action 1 on provideGenerationSuffixQuestion, so when the user clicks 'Back' on the question, it doesn't clear the typed answer.
export async function clearSuffixIfOther(suffix, extraSaves, question, application) {
	let provideGenerationSuffixQuestion = application.quoteAppData.questions.find(q => q.key == 'provideGenerationSuffix');

	if (provideGenerationSuffixQuestion?.savedAnswer == 'other') {
		application.quoteAppData.applicationsDataAnswered.personalInfo.generationSuffix = null;
		provideGenerationSuffixQuestion?.clearAnswer();
	}
}

export async function clearAddress(isUsOrTerritory, extraSaves, question, application) {
	let data = [];
	let applicationsDataAnswered = application.quoteAppData.applicationsDataAnswered;
	let personalInfo = applicationsDataAnswered.personalInfo;
	console.log('personalInfo :>> ', personalInfo.currentResidence.country);

	switch (question.key) {
		case 'liveInsideUS':
			if ((isUsOrTerritory && personalInfo.currentResidence.country != 'US') || (!isUsOrTerritory && personalInfo.currentResidence.country == 'US')) {
				data = [
					{ questionKey: 'provideZipCode', dataKey: null },
					{ questionKey: 'provideApartment', dataKey: null },
					{ questionKey: 'provideStreetAddress', dataKey: null },
					{ questionKey: 'provideOutsideUSStreetAddress', dataKey: null },
					{ questionKey: 'provideCity', dataKey: null },
					{ questionKey: 'provideState', dataKey: null },
					{ questionKey: 'provideOutsideUSState', dataKey: null },
					{ questionKey: 'provideCounty', dataKey: null },
				];

				if (isUsOrTerritory) {
					data.push({ questionKey: 'provideUSTerritory', dataKey: 'US' });
				} else {
					data.push({ questionKey: 'provideUSTerritory', dataKey: null });
				}
			}
			break;
		case 'liveInsideUSPreviously':
			if ((isUsOrTerritory && personalInfo.previousResidence.country != 'US') || (!isUsOrTerritory && personalInfo.previousResidence.country == 'US')) {
				data = [
					{ questionKey: 'providePreviousZipCode', dataKey: null },
					{ questionKey: 'providePreviousApartment', dataKey: null },
					{ questionKey: 'providePreviousStreetAddress', dataKey: null },
					{
						questionKey: 'providePreviousOutsideUSStreetAddress',
						dataKey: null,
					},
					{ questionKey: 'providePreviousCity', dataKey: null },
					{ questionKey: 'providePreviousState', dataKey: null },
					{ questionKey: 'providePreviousOutsideUSState', dataKey: null },
				];

				if (isUsOrTerritory) {
					data.push({
						questionKey: 'providePreviousUSTerritory',
						dataKey: 'US',
					});
				} else {
					data.push({
						questionKey: 'providePreviousUSTerritory',
						dataKey: null,
					});
				}
			}
			break;
	}
	if (data.length > 0) {
		updateData(data, application);
	}
}

export async function setUSTerritory(territory, extraSaves, question, application) {
	if (territory && territory != 'US') {
		if (question.key == 'provideStreetAddress') {
			application.quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.state = territory;
		} else {
			application.quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.state = territory;
		}
	}
}

export async function updateSelectedAddress(address, extraSaves, question, application, searchText) {
	if (extraSaves[0]?.description == '-- NOT LISTED --') {
		if (question.key == 'provideStreetAddress') {
			let territory = application.quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.usTerritory;
			let state = territory && territory != 'US' ? territory : null;

			application.quoteAppData.questions.find(q => q.key == 'provideCity').savedAnswer = null;
			application.quoteAppData.questions.find(q => q.key == 'provideState').savedAnswer = state;
			application.quoteAppData.questions.find(q => q.key == 'provideCounty').savedAnswer = null;
		} else {
			let territory = application.quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.usTerritory;
			let state = territory && territory != 'US' ? territory : null;

			application.quoteAppData.questions.find(q => q.key == 'providePreviousCity').savedAnswer = null;
			application.quoteAppData.questions.find(q => q.key == 'providePreviousState').savedAnswer = state;
			application.quoteAppData.questions.find(q => q.key == 'providePreviousCounty').savedAnswer = null;
		}

		return searchText;
	} else if (extraSaves[0].structured_formatting) {
		let address1 = extraSaves[0].structured_formatting.main_text;
		await saveSelectedAddressValues(address1, extraSaves, question, application);
		return address1;
	}
}

async function saveSelectedAddressValues(address, extraSaves, question, application) {
	if (extraSaves[0]?.place_id) {
		let mapService = new MapsService();

		await mapService.getAddressDetails(extraSaves[0], addressDetails => {
			let data = [];

			switch (question.key) {
				case 'provideStreetAddress': {
					let usTerritory = application.quoteAppData.applicationsDataAnswered.personalInfo.currentResidence.usTerritory;
					let state = usTerritory && usTerritory != 'US' ? usTerritory : addressDetails.state;

					data = [
						{ questionKey: 'provideZipCode', dataKey: addressDetails.zip },
						{ questionKey: 'provideStreetAddress', dataKey: address },
						{ questionKey: 'provideCity', dataKey: addressDetails.city },
						{ questionKey: 'provideState', dataKey: state },
						{ questionKey: 'provideCounty', dataKey: addressDetails.county },
					];
					break;
				}
				case 'providePreviousStreetAddress': {
					let usTerritory = application.quoteAppData.applicationsDataAnswered.personalInfo.previousResidence.usTerritory;
					let state = usTerritory && usTerritory != 'US' ? usTerritory : addressDetails.state;

					data = [
						{
							questionKey: 'providePreviousZipCode',
							dataKey: addressDetails.zip,
						},
						{ questionKey: 'providePreviousStreetAddress', dataKey: address },
						{
							questionKey: 'providePreviousCity',
							dataKey: addressDetails.city,
						},
						{ questionKey: 'providePreviousState', dataKey: state },
						{
							questionKey: 'providePreviousCounty',
							dataKey: addressDetails.county,
						},
					];
					break;
				}
			}

			let zipCode = null;
			let zipCodeKey = data.find(d => d.dataKey == addressDetails.zip).questionKey;
			let zipCodeQuestion = application.quoteAppData.questions.find(q => q.key == zipCodeKey);
			zipCode = zipCodeQuestion.getValue(zipCodeQuestion.dataStructurePath);

			if (addressDetails.zip && zipCode.slice(0, 5) != addressDetails.zip) {
				let title = null;
				let message = null;
				if (application.quoteAppData.language == 'English') {
					title = 'Zip Code Discrepancy';
					message = 'The zip code entered is different than the zip code we found. Please select which zip code is the correct one that should be used.';
				} else {
					title = 'Discrepancia en código postal';
					message =
						'El código postal ingresado es diferente al código postal que encontramos. Por favor seleccione el código postal correcto que debemos usar.';
				}
				//call modal
				$modal.open(modalConfirmCustomerApplicationInfo, {
					name: 'modalConfirmCustomerApplicationInfo',
					passedData: {
						title: title,
						info: message,
						alternativeValueText: addressDetails.zip,
						currentValueText: zipCode,
					},
					backdrop: false,
					postFunction: () => {
						updateData(
							data.filter(d => d.dataKey == addressDetails.zip),
							application,
						);
					},
				});
			}

			updateData(
				data.filter(d => d.dataKey != addressDetails.zip),
				application,
			);
		});
	}
}

function updateData(data, application) {
	data.forEach(d => {
		let questionToUpdate = application.quoteAppData.questions.find(q => q.key == d.questionKey);
		if (questionToUpdate) {
			questionToUpdate.savedAnswer = d.dataKey;
			questionToUpdate.setValue(d.dataKey);
		}
	});
}

export async function expirationDateInThePast(expirationDate, extraSaves, question, application) {
	if (moment(expirationDate, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]').diff(moment(), 'days') <= 0) {
		$modal.open(modalCustomerApplicationInfo, {
			name: 'modalCustomerApplicationInfo',
			passedData: {
				title: 'Expiration Date in the Past',
				info: 'Please note you entered a date in the past',
				acceptText: 'OK',
			},
			backdrop: false,
		});
	}
}

export async function redirectToCustomerPortalInApp(data, extraSaves, question, application) {
	settings.disableBrowserRedirectPopup = true;
	let linkForRedirect = await redirectToCustomerPortal(application.customerId);
	window.location.href = linkForRedirect;
}

export async function plateToVIN(state, extraSaves, question, application) {
	const storeCode = application.storeCode;
	const plateState = state;
	const plateNumberIndex = question.key.split('-')[1];
	let plateNumber = null;
	if (question.key.toLowerCase().includes('current')) {
		plateNumber = application.quoteAppData.applicationsDataAnswered.rebates.rebateCurrentVehicles.vehicles[plateNumberIndex].vehiclePlate;
	} else {
		plateNumber = application.quoteAppData.applicationsDataAnswered.rebates.rebateReturnedLeaseVehicles.vehicles[plateNumberIndex].vehiclePlate;
	}

	let response = await api.cbc.plateToVIN(storeCode, plateState, plateNumber);
	let index = question.key.split('-')[1];

	if (response.data?.vin) {
		await vinLookup(response.data.vin, extraSaves, question, application);
	} else {
		if (question.key.toLowerCase().includes('current')) {
			application.quoteAppData.questions.find(q => q.key == 'rebateCurrentVehiclesYear-' + index).savedAnswer = null;
			application.quoteAppData.questions.find(q => q.key == 'rebateCurrentVehiclesMake-' + index).savedAnswer = null;
			application.quoteAppData.questions.find(q => q.key == 'rebateCurrentVehiclesModel-' + index).savedAnswer = null;
		} else {
			application.quoteAppData.questions.find(q => q.key == 'rebateReturnedLeaseVehiclesYear-' + index).savedAnswer = null;
			application.quoteAppData.questions.find(q => q.key == 'rebateReturnedLeaseVehiclesMake-' + index).savedAnswer = null;
			application.quoteAppData.questions.find(q => q.key == 'rebateReturnedLeaseVehiclesModel-' + index).savedAnswer = null;
		}
	}
}

export async function vinLookup(vin, extraSaves, question, application) {
	let response = await api.vinLookup(vin);
	let index = question.key.split('-')[1];
	console.log('response', response);
	if (response && response.data) {
		if (question.key.toLowerCase().includes('current')) {
			application.quoteAppData.questions.find(q => q.key == 'rebateCurrentVehiclesYear-' + index).savedAnswer = `${response.data.payload.modelYear}`;
			application.quoteAppData.questions.find(q => q.key == 'rebateCurrentVehiclesMake-' + index).savedAnswer = `${response.data.payload.division}`;
			application.quoteAppData.questions.find(q => q.key == 'rebateCurrentVehiclesModel-' + index).savedAnswer = response.data.payload.modelName;
		} else {
			application.quoteAppData.questions.find(q => q.key == 'rebateReturnedLeaseVehiclesYear-' + index).savedAnswer = `${response.data.payload.modelYear}`;
			application.quoteAppData.questions.find(q => q.key == 'rebateReturnedLeaseVehiclesMake-' + index).savedAnswer = response.data.payload.division;
			application.quoteAppData.questions.find(q => q.key == 'rebateReturnedLeaseVehiclesModel-' + index).savedAnswer = response.data.payload.modelName;
		}
	} else {
		if (question.key.toLowerCase().includes('current')) {
			application.quoteAppData.questions.find(q => q.key == 'rebateCurrentVehiclesYear-' + index).savedAnswer = null;
			application.quoteAppData.questions.find(q => q.key == 'rebateCurrentVehiclesMake-' + index).savedAnswer = null;
			application.quoteAppData.questions.find(q => q.key == 'rebateCurrentVehiclesModel-' + index).savedAnswer = null;
		} else {
			application.quoteAppData.questions.find(q => q.key == 'rebateReturnedLeaseVehiclesYear-' + index).savedAnswer = null;
			application.quoteAppData.questions.find(q => q.key == 'rebateReturnedLeaseVehiclesMake-' + index).savedAnswer = null;
			application.quoteAppData.questions.find(q => q.key == 'rebateReturnedLeaseVehiclesModel-' + index).savedAnswer = null;
		}
	}
}

//export async function createNewApplication(value, extraSaves, question, application) {
//    // Only execute if the transaction is under a company and the applicant is the guarantor
//    if (application.isBusinessWithApplicantAsGuarantor()) {
//        // Create and save new lead
//        let lead = {
//            id: util.getGuid(),
//            firstName: application.preFilledData.firstName,
//            lastName: application.preFilledData.lastName,
//            fullName: application.preFilledData.firstName + ' ' + application.preFilledData.lastName,
//            phoneNumber: application.preFilledData.phoneNumber,
//            emailAddress: application.preFilledData.emailAddress,
//            dateOfBirth: application.preFilledData.dateOfBirth,
//            dateCreated: moment.utc().format()
//        }
//        console.log("LEAD OBJ", lead);
//        await api.customers.saveLead(lead)

//        // Create, populate, and save new Customer Application
//        let newApplicationObject = new Application()
//        newApplicationObject.isLatestApplication = true
//        newApplicationObject.dateCreated = moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]")
//        newApplicationObject.editLinkExpiration = moment("0001-01-01", "YYYY-MM-DD").format("YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]")
//        newApplicationObject.emailCodeExpiration = moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]")
//        newApplicationObject.phoneCodeExpiration = moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]")
//        newApplicationObject.id = util.getGuid()
//        newApplicationObject.customerId = util.getDefaultGuid()
//        newApplicationObject.leadId = lead.id
//        newApplicationObject.plaidId = application.plaidId
//        newApplicationObject.preFilledData = new ApplicationsPreFilledData(application.preFilledData)
//        newApplicationObject.quoteAppData.applicationsDataAnswered = new ApplicationsDataAnswered()
//        newApplicationObject.quoteAppData.applicationsDataAnswered.dealTypes = application.quoteAppData.applicationsDataAnswered.dealTypes
//        newApplicationObject.quoteAppData.applicationsDataAnswered.garagedAddress = application.quoteAppData.applicationsDataAnswered.garagedAddress
//        newApplicationObject.quoteAppData.applicationsDataAnswered.garagedAddressOutsideUS = application.quoteAppData.applicationsDataAnswered.garagedAddressOutsideUS
//        newApplicationObject.quoteAppData.applicationsDataAnswered.garagedAddressSameAsResidence = application.quoteAppData.applicationsDataAnswered.garagedAddressSameAsResidence
//        newApplicationObject.quoteAppData.applicationsDataAnswered.isBusiness = false
//        newApplicationObject.quoteAppData.applicationsDataAnswered.personalInfo = new ApplicationsPersonalInfo(application.quoteAppData.applicationsDataAnswered.personalInfo)
//        newApplicationObject.quoteAppData.applicationsDataAnswered.rebates = new ApplicationsRebates(application.quoteAppData.applicationsDataAnswered.rebates)
//        newApplicationObject.quoteAppData.currentQuestion = 'provideEstimateCreditScore'
//        newApplicationObject.quoteAppData.language = application.language

//        let newPathFollowedLastIndex = application.quoteAppData.pathFollowed.findIndex(key => key == 'isUnderBusiness')
//        newApplicationObject.quoteAppData.pathFollowed = application.quoteAppData.pathFollowed.slice(0, newPathFollowedLastIndex)

//        newApplicationObject.storeCode = application.storeCode
//        let applicationRequest = {
//            application: newApplicationObject,
//            isFinished: true,
//            isNewSession: true
//        }
//        await api.applications.saveNewApplication(applicationRequest)

//        // Add guarantor id to current business application and save it
//        application.guarantorApplicationId = newApplicationObject.id
//        api.applications.setGuarantorIdToCustomerApplication(application.id, application.guarantorApplicationId)

//        //await api.applications.saveApplication(currentApplicationRequest)

//        // Update local storage with the new application
//        const userData = util.encryptJSONText(JSON.stringify(newApplicationObject))
//        localStorage.setItem('applicationObject', userData)
//    }
//}

export async function reload(value, extraSaves, question, application) {
	window.location.reload();
}

export async function encryptTaxId(taxId, extraSaves, question, application) {
	//if current taxId is not hashed
	if (!taxId.startsWith('*****')) {
		try {
			let response = await api.utilities.encrypt(taxId);
			if (response.data) {
				application.quoteAppData.applicationsDataAnswered.businessInfo.taxIdHashed = response.data.encryptedValue;
				application.quoteAppData.applicationsDataAnswered.businessInfo.taxIdLast4 = `*****${taxId.substring(taxId.length - 4)}`;
				question.savedAnswer = application.quoteAppData.applicationsDataAnswered.businessInfo.taxIdLast4;
			}
		} catch (error) {
			LogRocket.log('Error encrypting SSN', error);
		}
	}
}

export async function checkCredit(ssn, extraSaves, question, application) {
	//if current ssn is not hashed
	if (ssn == null && !application.quoteAppData.applicationsDataAnswered.isBusiness) {
		await checkFrozen(application);
	} else if (!ssn.startsWith('*****')) {
		application.setSNNType(ssn);

		await api.utilities.encrypt(ssn).then(response => {
			if (response.data) {
				application.quoteAppData.applicationsDataAnswered.personalInfo.ssnHashed = response.data.encryptedValue;
				application.quoteAppData.applicationsDataAnswered.personalInfo.ssnLast4 = `*****${ssn.substring(ssn.length - 4)}`;
				question.savedAnswer = application.quoteAppData.applicationsDataAnswered.personalInfo.ssnLast4;
				application.quoteAppData.applicationsDataAnswered.personalInfo.lastSuccessfulCreditCheck = null;
			}
		});

		if (application.quoteAppData.applicationsDataAnswered.personalInfo.ssnType == ENUMS.SSN_TYPES.SSN) {
			await checkFrozen(application);
		}
	}
}

export async function checkCreditEquifax(value, extraSaves, question, application) {
	await checkFrozen(application, application.quoteAppData.applicationsDataAnswered.personalInfo.equifaxPIN);
}

export async function checkCreditExperian(value, extraSaves, question, application) {
	await checkFrozen(application, null, application.quoteAppData.applicationsDataAnswered.personalInfo.experianPIN);
}

export async function checkCreditTransUnion(value, extraSaves, question, application) {
	await checkFrozen(application, null, null, application.quoteAppData.applicationsDataAnswered.personalInfo.transUnionPIN);
}

export async function encryptSsn(ssn, extraSaves, question, application) {
	//if current ssn is not hashed
	if (!ssn.startsWith('*****')) {
		application.setSNNType(ssn);
		try {
			if (ssn == null) {
				util.toastr('error', 'Error', 'Error adding SSN. Please refresh and try again.');
				LogRocket.log('No ssn value', ssn);
				throw new Error('no ssn value');
			}
			const response = await api.utilities.encrypt(ssn);

			if (response?.data?.encryptedValue) {
				application.quoteAppData.applicationsDataAnswered.personalInfo.ssnHashed = response.data.encryptedValue;
				application.quoteAppData.applicationsDataAnswered.personalInfo.ssnLast4 = `*****${ssn.substring(ssn.length - 4)}`;
				question.savedAnswer = application.quoteAppData.applicationsDataAnswered.personalInfo.ssnLast4;
			} else {
				util.toastr('error', 'Error', 'Error encrypting SSN. Please refresh and try again.');
				LogRocket.log('Failed to encrypt SSN in the backend');
				throw new Error('Failed to encrypt SSN in the backend');
			}
		} catch (error) {
			util.toastr('error', 'Error', 'Error encrypting SSN. Please refresh and try again.');
			LogRocket.log('Error encrypting SSN', error);
			throw new Error('error encrypting');
		}
	}
}

async function checkFrozen(application, EquifaxPin = null, ExperianPin = null, TransUnionPin = null) {
	if (shouldWeCheckCredit(application)) {
		let experianFrozen = true;
		let transUnionFrozen = true;
		let equifaxFrozen = true;

		let req = {
			StoreCode: application.storeCode,
			AppID: application.id,
			ApplicantID: application.customerId,
			EquifaxPin: EquifaxPin,
			ExperianPin: ExperianPin,
			TransUnionPin: TransUnionPin,
			ReportType: reportTypeStringToEnum('XPN|TU|EFX'),
			SSN: application.quoteAppData.applicationsDataAnswered.personalInfo.ssnHashed,
		};

		await api.cbc
			.checkFrozen(req)
			.then(response => {
				experianFrozen = response.data.experianFrozen;
				transUnionFrozen = response.data.transUnionFrozen;
				equifaxFrozen = response.data.equifaxFrozen;

				if (response.data.success) {
					application.quoteAppData.applicationsDataAnswered.personalInfo.lastSuccessfulCreditCheck = new Date();
				}
			})
			.finally(() => {
				application.quoteAppData.applicationsDataAnswered.personalInfo.freezeWithExperian = experianFrozen;
				application.quoteAppData.applicationsDataAnswered.personalInfo.freezeWithTransUnion = transUnionFrozen;
				application.quoteAppData.applicationsDataAnswered.personalInfo.freezeWithEquifax = equifaxFrozen;
			});
	}
}

function shouldWeCheckCredit(application) {
	if (!application.quoteAppData.applicationsDataAnswered.personalInfo.lastSuccessfulCreditCheck) {
		return true;
	}

	let lastTime = moment(application.quoteAppData.applicationsDataAnswered.personalInfo.lastSuccessfulCreditCheck, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]');
	return Math.abs(moment().diff(lastTime, 'hours')) >= 24;
}

// Convert an enum string back to its enum type:
function reportTypeStringToEnum(inputString) {
	switch (inputString.toUpperCase()) {
		case 'XPN':
			return ENUMS.CBC_REPORT_TYPES.XPN;
		case 'TU':
			return ENUMS.CBC_REPORT_TYPES.TU;
		case 'EFX':
			return ENUMS.CBC_REPORT_TYPES.EFX;
		case 'XPN|TU':
			return ENUMS.CBC_REPORT_TYPES.XPN_TU;
		case 'XPN|EFX':
			return ENUMS.CBC_REPORT_TYPES.XPN_EFX;
		case 'TU|EFX':
			return ENUMS.CBC_REPORT_TYPES.TU_EFX;
		case 'XPN|TU|EFX':
			return ENUMS.CBC_REPORT_TYPES.XPN_TU_EFX;
	}
}
